import http from '../../../../libs/http'
import config from '../../../../config/shops'

export default ({ orderId }) => http.getUri({
  url: `${config.api}/order/${orderId}/export/excel`,
  method: 'get'
})
